import React, { useMemo } from "react";
import { Button } from "_c/button";
import PT from "prop-types";

const GoMailBtn = ({ email, t, onClose }) => {
  const link = useMemo(() => {
    if (!email) return null;
    if (email.includes("@gmail")) {
      return "https://mail.google.com/mail";
    } else if (email.includes("@yandex")) {
      return "https://mail.yandex.ru/";
    } else if (email.includes("@yahoo")) {
      return "https://mail.yahoo.com/";
    } else if (email.includes("@rambler")) {
      return "https://mail.rambler.ru/";
    } else if (email.includes("@mail")) {
      return "https://e.mail.ru/messages/";
    }
  });
  return (
    <div style={{ marginTop: "15px" }}>
      {link ? (
        <Button
          style={{ display: "inline-block" }}
          medium
          secondary
          as="a"
          href={link}
        >
          {t("login:open_mail")}
        </Button>
      ) : (
        <Button onClick={() => onClose()} medium>
          {t("common:close")}
        </Button>
      )}
    </div>
  );
};
GoMailBtn.propTypes = {
  email: PT.string.isRequired,

  onClose: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default GoMailBtn;
